export default {
  'article.guide.title': 'Przewodnik po arkuszu USFans: organizuj i kupuj cały katalog',
  'article.guide.desc':
    'Kompletny przewodnik po arkuszu USFans — jak porządkuje kategorie modowe, jak efektywnie przeglądać i sprytne porady zakupowe.',
  'article.guide.category': 'Kompletny przewodnik',

  'article.meta.title': 'Przewodnik po arkuszu USFans: organizuj i kupuj cały katalog',
  'article.meta.description':
    'Dowiedz się, jak arkusz USFans porządkuje buty, bluzy, koszulki sportowe i więcej w przejrzyste kategorie. Praktyczny przewodnik z poradami, porównaniami i FAQ.',
  'article.breadcrumb.home': 'Strona główna',
  'article.breadcrumb.current': 'Przewodnik po arkuszu USFans',

  'article.author': 'Zespół redakcyjny USFans Spreadsheet',
  'article.updated': 'Ostatnia aktualizacja',
  'article.minutes': 'min czytania',

  'article.intro.title': 'Wprowadzenie',
  'article.intro.p1':
    'Zakupy w dużym katalogu modowym mogą przytłaczać, zwłaszcza gdy produkty są rozproszone na dziesiątkach stron. Arkusz USFans powstał właśnie po to, aby rozwiązać ten problem: łączy buty, bluzy, koszulki, kurtki, koszulki sportowe, akcesoria i więcej w jeden uporządkowany, łatwy w nawigacji przegląd.',
  'article.intro.p2':
    'W tym przewodniku wyjaśniamy, czym jest arkusz USFans, jak działa jego system kategorii i jak szybciej znaleźć właściwy produkt — bez niekończącego się przewijania i zgadywania.',

  'article.what.title': 'Czym jest arkusz USFans?',
  'article.what.p1':
    'Arkusz USFans to uporządkowany katalog, który grupuje szeroką gamę odzieży modowej i gadżetów fanowskich w przejrzyste, logiczne kategorie. Zamiast przeglądać jeden nieuporządkowany strumień produktów, odwiedzający mogą od razu przejść do interesującej ich kategorii — butów, bluz i swetrów, koszulek, kurtek, spodni i szortów, nakryć głowy, zestawów, bielizny, koszulek sportowych, akcesoriów, toreb, pasków, perfum i innych rzeczy.',
  'article.what.p2':
    'Każda kategoria prowadzi do dedykowanej sekcji głównego sklepu, więc zawsze trafiasz dokładnie tam, gdzie trzeba. Ta struktura sprawia, że arkusz USFans jest przydatny zarówno jako szybkie narzędzie nawigacji, jak i planowanie kolejnego zakupu.',

  'article.categories.title': 'Jak działa system kategorii',
  'article.categories.p1':
    'Katalog jest podzielony na czternaście intuicyjnych kategorii. Oto, jak każda z nich pomaga zawęzić wyszukiwanie:',
  'article.categories.bullet1': 'Buty — sneakersy, obuwie codzienne i sportowe.',
  'article.categories.bullet2': 'Bluzy/Swetry — przytulne bluzy i dzianiny do warstwowania.',
  'article.categories.bullet3': 'Koszulki — codzienne t-shirty w różnych krojach i wzorach.',
  'article.categories.bullet4': 'Kurtki — odzież wierzchnia od lekkich warstw po cieplejsze płaszcze.',
  'article.categories.bullet5': 'Spodnie/Szorty — dół garderoby na każdą porę roku.',
  'article.categories.bullet6': 'Nakrycia głowy — czapki, beanie i inne dodatki na głowę.',
  'article.categories.bullet7': 'Zestawy — dopasowane stylizacje pakowane razem.',
  'article.categories.bullet8': 'Bielizna/Majtki — podstawowe elementy i bielizna.',
  'article.categories.bullet9': 'Koszulki sportowe — koszulki drużynowe i sportowe.',
  'article.categories.bullet10': 'Akcesoria — drobne elementy dopełniające stylizację.',
  'article.categories.bullet11': 'Torby — plecaki, torby i codzienne opcje przenoszenia.',
  'article.categories.bullet12': 'Paski — paski do spodni w różnych stylach.',
  'article.categories.bullet13': 'Perfumy — zapachy do użytku osobistego lub na prezent.',
  'article.categories.bullet14': 'Inne rzeczy — wszystko, co nie pasuje do powyższych kategorii.',

  'article.how.title': 'Jak efektywnie przeglądać katalog',
  'article.how.p1':
    'Zacznij od określenia, czego naprawdę potrzebujesz. Jeśli szukasz konkretnego produktu, użyj listy rozwijanej lub przycisków kategorii na stronie głównej, aby od razu przejść do tej sekcji. Jeśli tylko przeglądasz, najpierw zajrzyj do popularnych kategorii.',
  'article.how.p2':
    'Gdy już jesteś w kategorii, obejrzyj cały wybór przed podjęciem decyzji. Porównanie kilku opcji w tej samej kategorii — zamiast skakania między niepowiązanymi produktami — zwykle prowadzi do lepszego wyboru i mniejszej liczby rozczarowań.',
  'article.how.tip1': 'Korzystaj z kategorii zamiast zgadywać frazy wyszukiwania.',
  'article.how.tip2': 'Porównaj kilka pozycji w tej samej kategorii.',
  'article.how.tip3': 'Sprawdź dostępność i szczegóły przed sfinalizowaniem.',

  'article.comparison.title': 'Arkusz USFans a nieuporządkowane przeglądanie',
  'article.comparison.p1':
    'Różnica między uporządkowanym katalogiem a nieuporządkowaną listą produktów jest znacząca. Poniższa tabela podsumowuje, jak podejście arkusza USFans wypada na tle innych sposobów przeglądania.',
  'article.comparison.col1': 'Podejście',
  'article.comparison.col2': 'Organizacja',
  'article.comparison.col3': 'Szybkość znalezienia produktu',
  'article.comparison.col4': 'Najlepsze zastosowanie',
  'article.comparison.r1c1': 'Arkusz USFans',
  'article.comparison.r1c2': 'Wysoka',
  'article.comparison.r1c3': 'Szybko',
  'article.comparison.r1c4': 'Uporządkowane zakupy',
  'article.comparison.r2c1': 'Losowe wyszukiwanie',
  'article.comparison.r2c2': 'Niska',
  'article.comparison.r2c3': 'Wolno',
  'article.comparison.r2c4': 'Szybkie jednorazowe wyszukiwania',
  'article.comparison.r3c1': 'Jedna długa lista',
  'article.comparison.r3c2': 'Średnia',
  'article.comparison.r3c3': 'Średnio',
  'article.comparison.r3c4': 'Przeglądanie dla inspiracji',

  'article.tips.title': 'Sprytne porady zakupowe',
  'article.tips.p1':
    'Odrobina przygotowania sprawia, że zakupy online są płynniejsze i bezpieczniejsze. Pamiętaj o tych praktycznych wskazówkach podczas korzystania z arkusza USFans:',
  'article.tips.tip1': 'Dokładnie sprawdź szczegóły, rozmiary i dostępność przed zamówieniem.',
  'article.tips.tip2': 'Przejrzyj informacje o wysyłce i zwrotach w samym sklepie.',
  'article.tips.tip3': 'Chroń dane płatności i kupuj tylko w oficjalnym sklepie.',
  'article.tips.tip4': 'Wracaj do katalogu, gdy pojawiają się nowości lub nowe sezony.',

  'article.faq.title': 'Często zadawane pytania',
  'article.faq.q1': 'Czym jest arkusz USFans?',
  'article.faq.a1':
    'To uporządkowany katalog, który grupuje odzież modową i gadżety fanowskie w przejrzyste kategorie, dzięki czemu szybciej znajdziesz buty, bluzy, koszulki sportowe, akcesoria i więcej.',
  'article.faq.q2': 'Jak szybko znaleźć konkretny produkt?',
  'article.faq.a2':
    'Użyj listy rozwijanej lub przycisków kategorii na stronie głównej, aby od razu przejść do potrzebnej sekcji.',
  'article.faq.q3': 'Czy arkusz USFans to sklep?',
  'article.faq.a3':
    'To źródło informacji i nawigacji. Zakupy są finalizowane w głównym sklepie, do którego prowadzi.',
  'article.faq.q4': 'Jak często aktualizowany jest katalog?',
  'article.faq.a4':
    'Kategorie są utrzymywane w zgodzie z głównym sklepem, więc nowości i produkty sezonowe pojawiają się, gdy stają się dostępne.',

  'article.cta.title': 'Gotowy, aby przejrzeć cały katalog?',
  'article.cta.p1':
    'Skoro już wiesz, jak działa arkusz USFans, wróć na stronę główną, aby przejrzeć kategorie, lub odwiedź sklep bezpośrednio, aby zacząć zakupy.',
  'article.cta.back': 'Wróć na stronę główną',
  'article.cta.store': 'Odwiedź sklep',

  'article.disclaimer':
    'Zastrzeżenie: USFanslink.makeup jest niezależnym źródłem informacji. Dostępność, ceny i zasady produktów są zarządzane przez powiązany sklep i mogą ulec zmianie. Zawsze weryfikuj istotne szczegóły bezpośrednio w sklepie przed zakupem.',
};